import '.ip{border-bottom:1px solid var(--brand-secondary);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.iq{padding:1.5rem 0;}.ssr-plugin'
import '.ck{border:none;}.ssr-plugin'
import '.cm{background:transparent;}.ssr-plugin'
import '.a7{cursor:pointer;}.ssr-plugin'
import '.h0{text-align:left;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.fa{width:1.5rem;}.ssr-plugin'
import '.ir{font-size:1.25rem;}.ssr-plugin'
import '.dk{font-weight:700;}.ssr-plugin'
import '.is{padding-bottom:1.125rem;}.ssr-plugin'
import { useId, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { type Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'

export type FaqItemProps = {
  question: string
  answer: string
  style?: Style
}

export const FaqItem = ({ question, answer, style }: FaqItemProps) => {
  const baseId = useId()
  const panelId = `${baseId}-panel`
  const triggerId = `${baseId}-trigger`
  const [open, setOpen] = useState(false)

  return (
    <styled.div className="ip"
      style={{
        ...style,
      }}
    >
      <button className="d n iq ck cm a7 h0"
        type="button"
        id={triggerId}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <Title.H3
          style={{
            flex: 1,
            margin: 0,
          }}
        >
          {question}
        </Title.H3>
        <span className="ah d z ad fa ir dk"
          aria-hidden
        >
          <FontAwesomeIcon icon={open ? faMinus : faPlus} />
        </span>
      </button>
      {open ? (
        <div className="is"
          id={panelId}
          role="region"
          aria-labelledby={triggerId}
        >
          <Text.Medium
            style={{
              margin: 0,
              color: 'var(--brand-secondary)',
              opacity: 0.85,
              lineHeight: '1.45',
              fontWeight: 400,
            }}
          >
            {answer}
          </Text.Medium>
        </div>
      ) : null}
    </styled.div>
  )
}
